import React from "react";

import { useNavigate } from "react-router-dom";

import {
  MenuRounded,
  NoMealsRounded,
  NotificationAddRounded,
  SettingsRounded,
  StorefrontRounded,
} from "@mui/icons-material";
import { Alert, Box } from "@mui/material";

import useMainState from "../../../config/context/mainStateContext";
import useModal from "../../../config/context/modalContext";
import { CafeteriaService } from "../../../config/services/CafeteriaService";
import useCafeteria from "../context";

import CafeteriaOrder from "../../../components/CafeteriaOrder";
import SwitchMain from "../../../components/InputMain/SwitchMain";
import MainSolidButton from "../../../components/MainSolidButton";
import MainText from "../../../components/MainText";
import PageHeader from "../../../components/PageHeader";

export default function DashboardTab() {
  const navigate = useNavigate();

  const CafeteriaUpdate = CafeteriaService.Update();
  const { setShowSideMenuDrawer } = useMainState();

  const { pushAlert, showImage } = useModal();

  const { currentCafeteria, handleGetCafeterias, isLoadingCafeterias } = useCafeteria();

  const [isOpen, setIsOpen] = React.useState(currentCafeteria?.isOpen || false);

  const [enableReserve, setEnableReserve] = React.useState(
    currentCafeteria?.config.enableReserve || false
  );

  //

  const handleUpdateField = async () => {
    await CafeteriaUpdate.runRequest(currentCafeteria?.id || "", {
      isOpen,
      config: {
        enableReserve,

        autoClose: "",
      },
    })
      .then(() => {
        pushAlert({ type: "success", message: "Lanchonete atualizada. " });
        handleGetCafeterias();
      })
      .catch((err) =>
        pushAlert({ type: "error", message: "Erro ao atualizar lanchonete. " + err.message })
      );
  };

  React.useEffect(() => {
    if (
      isOpen !== currentCafeteria?.isOpen ||
      enableReserve !== currentCafeteria?.config.enableReserve
    ) {
      handleUpdateField();
    }
  }, [isOpen, enableReserve]);

  return (
    <Box>
      <PageHeader
        title="Lanchonete"
        leftIcon={<MenuRounded />}
        onLeftAction={() => setShowSideMenuDrawer(true)}
        rightIcon={<SettingsRounded />}
        onRightAction={() => navigate("/cafeteria/settings")}
      />

      <Alert
        icon={
          isOpen ? <StorefrontRounded fontSize="inherit" /> : <NoMealsRounded fontSize="inherit" />
        }
        severity={isOpen ? "success" : "error"}
        sx={{ mb: 2 }}
      >
        {isOpen ? "Lanchonete Aberta" : "Lanchonete Fechada"}
      </Alert>

      <SwitchMain
        disabled={isLoadingCafeterias}
        loading={isLoadingCafeterias}
        name={"Aberto"}
        small={"Informa aos usuários que a lanchonete está aberta"}
        checked={isOpen}
        onChange={(checked) => {
          setIsOpen(checked);
        }}
      />

      <MainSolidButton text="Enviar Notificação" icon={<NotificationAddRounded />} />

      <Box mb={1} mt={2}>
        <MainText size="body" color="black">
          Novos Pedidos
        </MainText>
      </Box>

      <CafeteriaOrder />
      <CafeteriaOrder />
    </Box>
  );
}
